import React from 'react';

function useScaledBoxes({ dependencies }) {
  const firstItemRef = React.useRef();
  const secondItemRef = React.useRef();

  const [firstBB, setFirstBB] = React.useState(null);
  const [secondBB, setSecondBB] = React.useState(null);

  const [scale, setScale] = React.useState(1);

  const freshScale = React.useRef();
  freshScale.current = scale;

  // Because we scale the demo down on mobile, we need to do a bit
  // more work to calculate the actual sizes measured by the
  // bounding boxes
  const firstBBWidth = firstBB
    ? firstBB.width * (1 / scale)
    : undefined;
  const secondBBWidth = secondBB
    ? secondBB.width * (1 / scale)
    : undefined;

  React.useEffect(() => {
    if (!firstItemRef.current || !secondItemRef.current) {
      return;
    }

    setFirstBB(firstItemRef.current.getBoundingClientRect());
    setSecondBB(secondItemRef.current.getBoundingClientRect());
    // ESLint doesn't like the spread in dependencies.
    // eslint-disable-next-line
  }, [...dependencies, scale]);

  React.useEffect(() => {
    function calculateScale() {
      const windowWidth = window.innerWidth;
      const requiredSpace = 612 + 16 * 2 + 32;

      if (windowWidth < requiredSpace) {
        setScale(windowWidth / requiredSpace);
      } else if (freshScale.current !== 1) {
        setScale(1);
      }
    }

    calculateScale();

    window.addEventListener('resize', calculateScale);

    return () => {
      window.removeEventListener('resize', calculateScale);
    };
  }, []);

  return {
    scale,
    firstItemRef,
    secondItemRef,
    firstBBWidth,
    secondBBWidth,
  };
}

export default useScaledBoxes;
